import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { findDOMNode } from 'react-dom';
import { Manager, Popper, Reference } from 'react-popper';
import { shadow3 } from '../styles/util';
import { StyledFlyover, StyledFlyoverWrapper } from './FlyoverBuilder.styled';
export var FlyoverBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(FlyoverBuilder, _React$Component);
  var _super = _createSuper(FlyoverBuilder);
  function FlyoverBuilder() {
    var _this;
    _classCallCheck(this, FlyoverBuilder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "flyoverWrapperRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "buttonId", "id".concat(Math.random()));
    _defineProperty(_assertThisInitialized(_this), "shouldClose", false);
    _defineProperty(_assertThisInitialized(_this), "handleClickToggle", function () {
      if (_this.isControlled()) {
        return;
      }
      if (_this.shouldOpenOnClick() && (_this.props.toggleOnClick || !_this.state.isOpen)) {
        _this.toggleFlyover(!_this.state.isOpen);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleFlyoverClick", function (e) {
      if (_this.isControlled()) {
        return;
      }
      e.stopPropagation();
      _this.toggleFlyover(false);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      if (_this.isControlled()) {
        return;
      }
      _this.shouldClose = false;
      if (_this.state.isOpen) {
        return;
      }
      _this.toggleFlyover(true);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      if (_this.isControlled()) {
        return;
      }
      if (!_this.state.isOpen) {
        return;
      }
      _this.shouldClose = true;
      setTimeout(function () {
        if (_this.shouldClose) {
          _this.toggleFlyover(false);
        }
      }, 250);
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (e) {
      if (_this.isControlled()) {
        return;
      }
      if (e.key === 'Enter' && _this.props.openOn === 'hover') {
        _this.toggleFlyover(!_this.state.isOpen);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      if (_this.isControlled()) {
        return;
      }
      var nextElement = e.relatedTarget || document.activeElement; // use document.activeElement for IE
      if (_this.flyoverWrapperRef.current && !_this.flyoverWrapperRef.current.contains(nextElement)) {
        _this.closeFlyover();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var domNode = findDOMNode(_assertThisInitialized(_this));
      if (!(domNode !== null && domNode !== void 0 && domNode.contains(e.target))) {
        _this.closeFlyover();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleFlyover", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      }, function () {
        return _this.props.onToggle && _this.props.onToggle(_this.state.isOpen);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closeFlyover", function () {
      setTimeout(function () {
        return _this.toggleFlyover(false);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.key === 'Escape') {
        _this.closeFlyover();
      }
    });
    return _this;
  }
  _createClass(FlyoverBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$props$isOpen;
      var children = this.props.children;
      var hoverHandlers = this.shouldOpenOnHover() ? {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      } : {};
      var buttonId = this.props.buttonId || this.buttonId;
      var flyover = this.props.flyover;
      if (typeof this.props.flyover === 'function') {
        flyover = this.props.flyover({
          closeFlyover: this.closeFlyover
        });
      }
      return /*#__PURE__*/React.createElement(StyledFlyoverWrapper, {
        ref: this.flyoverWrapperRef,
        onKeyDown: this.handleKeyDown
      }, /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref) {
        var _this2$props$isOpen;
        var ref = _ref.ref;
        return (
          /*#__PURE__*/
          // This handles hiding the flyover when focusing on another element and doesn't need an aria role.
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          React.createElement("div", _extends({
            ref: ref
          }, hoverHandlers, {
            onBlur: _this2.onBlur
          }), children({
            'aria-expanded': (_this2$props$isOpen = _this2.props.isOpen) !== null && _this2$props$isOpen !== void 0 ? _this2$props$isOpen : _this2.state.isOpen,
            'aria-haspopup': true,
            id: buttonId,
            onClick: _this2.handleClickToggle,
            onKeyUp: _this2.onKeyUp
          }))
        );
      }), ((_this$props$isOpen = this.props.isOpen) !== null && _this$props$isOpen !== void 0 ? _this$props$isOpen : this.state.isOpen) && /*#__PURE__*/React.createElement(Popper, {
        placement: this.props.placement,
        strategy: "fixed",
        modifiers: [{
          name: 'computeStyles',
          options: {
            gpuAcceleration: false
          }
        }, {
          name: 'sameWidth',
          enabled: this.props.sameWidth || false,
          phase: 'beforeWrite',
          requires: ['computeStyles'],
          fn: function fn(_ref2) {
            var state = _ref2.state;
            state.styles.popper.width = "".concat(state.rects.reference.width, "px");
          },
          effect: function effect(_ref3) {
            var state = _ref3.state;
            state.elements.popper.style.width = "".concat(state.elements.reference.getBoundingClientRect().width, "px");
          }
        }]
      }, function (_ref4) {
        var placement = _ref4.placement,
          ref = _ref4.ref,
          style = _ref4.style;
        return /*#__PURE__*/React.createElement(StyledFlyover, _extends({
          ref: ref,
          style: _objectSpread(_objectSpread(_objectSpread({}, style), {}, {
            zIndex: _this2.props.zIndex
          }, _this2.props.enableScrollY ? {
            overflowY: 'auto'
          } : {}), {}, {
            maxHeight: '-webkit-fill-available',
            boxShadow: shadow3.boxShadow
          }),
          "data-placement": placement,
          role: "menu",
          "aria-labelledby": _this2.props['aria-labelledby'] || buttonId,
          onClick: _this2.props.closeOnFlyoverClick ? _this2.handleFlyoverClick : undefined
        }, hoverHandlers, {
          onBlur: _this2.onBlur,
          tabIndex: -1
        }), flyover);
      })));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (this.isControlled()) {
        return;
      }
      if (this.state.isOpen && !prevState.isOpen) {
        this.addEventListener();
      } else if (!this.state.isOpen && prevState.isOpen) {
        this.removeEventListener();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.isControlled()) {
        return;
      }
      this.removeEventListener();
    }
  }, {
    key: "supportsHover",
    value: function supportsHover() {
      return window.matchMedia('(any-hover: hover)').matches;
    }
  }, {
    key: "shouldOpenOnClick",
    value: function shouldOpenOnClick() {
      return !this.supportsHover() || this.shouldOpenOnEvent('click') || this.shouldOpenOnEvent('hoverAndClick');
    }
  }, {
    key: "shouldOpenOnHover",
    value: function shouldOpenOnHover() {
      return this.supportsHover() && (this.shouldOpenOnEvent('hover') || this.shouldOpenOnEvent('hoverAndClick'));
    }
  }, {
    key: "shouldOpenOnEvent",
    value: function shouldOpenOnEvent(event) {
      var _this$props$openOn = this.props.openOn,
        openOn = _this$props$openOn === void 0 ? 'click' : _this$props$openOn;
      return !this.props.disabled && openOn === event;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener() {
      document.addEventListener('mousedown', this.handleClick, true);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener() {
      document.removeEventListener('mousedown', this.handleClick, true);
    }
  }, {
    key: "isControlled",
    value: function isControlled() {
      return this.props.isOpen !== undefined;
    }
  }]);
  return FlyoverBuilder;
}(React.Component);
_defineProperty(FlyoverBuilder, "defaultProps", {
  zIndex: 1,
  placement: 'bottom-start'
});